import { Card, CardContent, Typography } from '@mui/material';
import Grid from 'components/core/Grid';

interface Props {
  headerText: string;
}

export const DrawerHeader = ({ headerText }: Props) => {
  return (
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Typography variant="body2">{headerText}</Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};
